'use client'

import { useEffect } from 'react'
import { reportClientError } from '@/lib/report-client-error'

// Replaces the whole document when the layout itself crashes — which
// [locale]/error.tsx cannot catch, since it renders inside that layout. No
// providers exist here (no translations, no theme), so it stays plain English.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
    reportClientError('render', error)
  }, [error])

  return (
    <html lang="en">
      <body style={{ fontFamily: 'system-ui, sans-serif', display: 'grid', placeItems: 'center', minHeight: '100vh', margin: 0 }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 48, fontWeight: 700, color: '#6b7280', margin: 0 }}>500</p>
          <h1 style={{ fontSize: 22 }}>Something went wrong</h1>
          <button onClick={reset} style={{ padding: '8px 16px', cursor: 'pointer' }}>
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
